import {
  Card,
  CardContent,
  Grid,
  Typography,
  Avatar,
  Radio,
  Link
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { useState } from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import goodalipi from 'src/plugins/goodalipi';

// Custom radio icon
const BpIcon = styled('span')(() => ({
  borderRadius: '50%',
  width: 18,
  height: 18,
  backgroundColor: 'white',
}));

const StatusCount = ({ settingStatus, totalAppointmentsCount, ...props }) => {
  const navigate = useNavigate();

  const redirectToEmployee = (status) => {
    if (!status.showInEmployees || goodalipi.get('isMinor') === "isBooleantrue") {
      return;
    }
    window.sessionStorage.setItem('statusId', JSON.stringify(status.statusId));
    navigate('/app/employees', { replace: true });
  };

  const handleChange = (e) => {
    if (props.statusSelected === e.target.value) {
      settingStatus('');
    } else {
      settingStatus(props.status.status);
    }
  };

  return (
    <Grid {...props} container>
      <Grid
        item
        container
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          position: 'relative',
          bgcolor: props.status.darkColor,
          borderRadius: '15px 15px 0px 0px'
        }}
      >
        {props.selectFeature && (
          <Radio
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              bottom: 0
            }}
            icon={<BpIcon />}
            checked={props.statusSelected === props.status.status}
            value={props.status.status}
            onClick={handleChange}
            color="primary"
            disableRipple
            size="small"
          />
        )}

        <Typography
          color="textSecondary"
          sx={{
            mb: 0.5,
            mt: 1,
            fontWeight: 500,
          }}
          variant="caption"
        >
          {props.status.status}
        </Typography>
      </Grid>

      <Grid
        item
        container
        sx={{
          minHeight: '50px',
          bgcolor: `${props.status.bgColor}99`,
          borderRadius: '0px 0px 15px 15px'
        }}
        alignItems="center"
        justifyContent="center"
      >
        <Typography
          color="textSecondary"
          variant="h4"
          sx={{ fontSize: '18px' }}
        >
          {props.status.totalCount ? (
            props.selectFeature ? (
              <span>
                <span
                  className={
                    props.status.totalCount === 'NA'
                      ? 'gray-color'
                      : 'secondary-color'
                  }
                >
                  {props.status.totalCount}
                </span>
                <br />
                {totalAppointmentsCount &&
                props.status.status !== 'Total Appointments' &&
                props.status.totalCount !== 'NA' ? (
                  <span>
                    {(
                      (props.status.totalCount * 100) /
                      totalAppointmentsCount
                    ).toFixed(2)}
                    %
                  </span>
                ) : (
                  <span />
                )}
              </span>
            ) : (
              <Link
                component={RouterLink}
                onClick={() => {
                  redirectToEmployee(props.status);
                }}
                className={
                  (props.status.totalCount === 'NA'
                    ? 'no-pointers'
                    : 'cursor-pointer') + ' pull-right'
                }
                to="/app/employees"
              >
                <span
                  className={
                    props.status.totalCount === 'NA'
                      ? 'gray-color'
                      : 'secondary-color'
                  }
                >
                  {props.status.totalCount}
                </span>
              </Link>
            )
          ) : (
            <div className="p-r-15 pull-right m-t-10">
              <div className="dot-flashing"></div>
            </div>
          )}
        </Typography>
      </Grid>
    </Grid>
  );
};

StatusCount.propTypes = {
  settingStatus: PropTypes.func,
  selectFeature: PropTypes.bool,
  statusSelected: PropTypes.string
};

export default StatusCount;
